// SubmitButton.jsx
import React from 'react';
import plus from '../../assets/+.svg';
import CircularProgress from '@mui/material/CircularProgress';

export default function SubmitButton({ disabled = false, loading = false }) {
  return (
    <div className="form-button" style={{ marginTop: 40 }}>
      <button
        style={{ cursor: disabled ? 'not-allowed' : 'pointer', position: 'relative' }}
        type="submit"
        className="form-submit"
        disabled={disabled}
      >
        {loading ? (
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <CircularProgress size={18} />
            <span className="form-submit-text">Saving…</span>
          </span>
        ) : (
          <>
            <img src={plus} alt="plus" className="form-button-expense" />
            &nbsp;<span className="form-submit-text">Save Expense</span>
          </>
        )}
      </button>
    </div>
  );
}
